import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SearchEmailBuilderTemplatesResponse } from '@vendasta/email-builder/lib/_internal';
import { TemplatesService } from '@vendasta/email-builder';
import { AppNamespace } from '@vendasta/email-builder/lib/templates.service';
import { Template } from './card/card.component';
import { OwnerType } from '@vendasta/email-builder';
import { PAGE_ROUTES } from '../shared';

export interface SearchProvider {
  searchTemplates( //
    ownerType: OwnerType,
    ownerId: string,
    appNamespace: AppNamespace,
    searchTerm: string,
    pageSize: number,
    cursor?: string,
  ): Observable<SearchEmailBuilderTemplatesResponse>;
}

const pageSize = 12;

@Injectable({
  providedIn: 'root',
})
export class PaginatedSearcherService {
  constructor(@Inject(TemplatesService) private readonly templatesService: SearchProvider) {}

  loadPage(
    ownerType: OwnerType, //
    ownerId: string,
    appNamespace: AppNamespace,
    searchTerm: string,
    cursor: string,
  ): Observable<{
    items: Template[];
    cursor: string;
    hasMore: boolean;
    totalResults: number;
  }> {
    return this.templatesService
      .searchTemplates(
        ownerType,
        ownerId,
        appNamespace, //
        searchTerm,
        pageSize,
        cursor,
      )
      .pipe(
        map((r) => ({
          items: this.toTemplates(r),
          cursor: r.pagingMetadata.nextCursor,
          hasMore: r.pagingMetadata.hasMore,
          totalResults: r.hits,
        })),
      );
  }

  private toTemplates(resp: SearchEmailBuilderTemplatesResponse): Template[] {
    return resp.templates.map(
      (t) =>
        ({
          templateId: t.templateId,
          title: t.templateDisplayName,
          previewUrl: t.previewUrl,
          created: t.created,
          updated: t.updated,
          editorUrl: './' + PAGE_ROUTES.ROOT.TEMPLATE_SUBROUTES.EDIT(t.templateId),
          templateHtml: t.templateHtml,
          templateJson: t.templateJson,
          templateSubject: t.templateSubject,
        } as Template),
    );
  }
}
